// src/v2/components/InfoCard/info-card.js
import React from "react"
import PropTypes from "prop-types"
import {Paper, Typography, Box} from "@mui/material"
import theme from "../../theme/theme"

const InfoCard = ({
                      label,
                      height = 150,
                      align = "center",
                      onClick,
                      imageBackground,
                      children,
                      icon
                  }) => {
    const isTopRight = align === "top-right"

    return (
        <Paper
            elevation={3}
            onClick={onClick}
            sx={{
                height,
                p: 2,
                display: "flex",
                position: "relative",
                alignItems: isTopRight ? "flex-start" : "flex-end",
                justifyContent: isTopRight ? "flex-start" : "flex-start",
                borderRadius: 1,
                cursor: onClick ? "pointer" : "default",
                backgroundImage: `url(${imageBackground || ""})`,
                backgroundSize: "600% auto",
                backgroundPosition: "80% 30%",
                transition: "0.2s",
                "&:hover": onClick
                    ? {
                        transform: "scale(1.01)",
                    }
                    : undefined,
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    p: 1,
                    color: theme.palette.icon.main,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {React.cloneElement(icon, {
                    sx: {
                        fontSize: 40,        // aumenta o tamanho
                        color: theme.palette.icon.main,
                    },
                })}
            </Box>

            <Box
                sx={{
                    ml: isTopRight ? "auto" : 0,
                    mt: isTopRight ? 1 : 0,
                }}
            >
                <Typography
                    variant="h3"
                    color={"common.white"}
                    sx={{fontWeight: 600}}
                >
                    {label}
                </Typography>

                {children && (
                    <Box sx={{mt: 1}}>
                        {children}
                    </Box>
                )}
            </Box>
        </Paper>
    )
}

InfoCard.propTypes = {
    label: PropTypes.string.isRequired,
    height: PropTypes.number,
    imageBackground: PropTypes.string,
    align: PropTypes.oneOf(["center", "top-right"]),
    gradient: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
    icon: PropTypes.element,
}

export default InfoCard